<ng-container *ngFor="let tabItem of tabItems">
	<a (click)="closeMenuPanel()" [routerLink]="tabItem.internalRouterLink" routerLinkActive="active">
		<i class="fa fa-{{ tabItem.icon }}"></i> {{ tabItem.title }}
	</a>
</ng-container>
